import _defineProperty from"/builds/letote/wechat-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";import _classCallCheck from"/builds/letote/wechat-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";import _createClass from"/builds/letote/wechat-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";var _AppUrlUtil$QueryGrou;import queryString from'query-string';var ReferralGroup;(function(ReferralGroup){ReferralGroup["referral_code"]="referral_code";})(ReferralGroup||(ReferralGroup={}));var UTMGroup;(function(UTMGroup){UTMGroup["utm_source"]="utm_source";UTMGroup["utm_medium"]="utm_medium";UTMGroup["utm_campaign"]="utm_campaign";})(UTMGroup||(UTMGroup={}));export var AppUrlQueryGroup;/**
 * Url处理工具函数集
 *
 * @export
 * @class AppUrlUtil
 */(function(AppUrlQueryGroup){AppUrlQueryGroup["UTM"]="UTM";AppUrlQueryGroup["referral"]="Referral";})(AppUrlQueryGroup||(AppUrlQueryGroup={}));export var AppUrlUtil=/*#__PURE__*/function(){function AppUrlUtil(){_classCallCheck(this,AppUrlUtil);}_createClass(AppUrlUtil,null,[{key:"getQueryGroupObject",/**
   * 常用Query组字段名
   *
   * @static
   * @memberof AppUrlUtil
   */ /**
   * 获得常用Query组对象
   *
   * @static
   * @param {AppUrlQueryGroup[]} groups
   * @returns {{
   *     [key: string]: string
   *   }}
   * @memberof AppUrlUtil
   */value:function getQueryGroupObject(groups){var _this=this;var result={};var currentUrlQuery=queryString.parse(window.location.search);groups.forEach(function(group){var fields=_this.QueryGroupFields[group];if(fields){fields.forEach(function(name){if(currentUrlQuery[name]){result[name]=currentUrlQuery[name];}});}});return result;}/**
   * 获得常用Query组字符串
   *
   * @static
   * @param {AppUrlQueryGroup[]} groups
   * @param {boolean} [encode=true]
   * @returns
   * @memberof AppUrlUtil
   */},{key:"getQueryGroupString",value:function getQueryGroupString(groups){var encode=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var object=this.getQueryGroupObject(groups);return queryString.stringify(object,{encode:encode});}/**
   * 获取指定字段列表query对象
   *
   * @static
   * @param {string[]} fields
   * @returns
   * @memberof AppUrlUtil
   */},{key:"getQueryFieldsObject",value:function getQueryFieldsObject(fields){var result={};var currentUrlQuery=queryString.parse(window.location.search);fields.forEach(function(field){if(currentUrlQuery[field]){result[field]=currentUrlQuery[field];}});return result;}/**
   * 获取指定字段列表query字符串
   *
   * @static
   * @param {string[]} fields
   * @param {boolean} [encode=true]
   * @returns
   * @memberof AppUrlUtil
   */},{key:"getQueryFieldsString",value:function getQueryFieldsString(fields){var encode=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var object=this.getQueryFieldsObject(fields);return queryString.stringify(object,{encode:encode});}/**
   * 获得地址对象url字符
   *
   * @static
   * @param {{
   *     host: string
   *     pathname: string
   *     query: { [key: string]: any }
   *   }} object
   * @returns
   * @memberof AppUrlUtil
   */},{key:"getUrlString",value:function getUrlString(object){var host=object.host,pathname=object.pathname,query=object.query;var filterQuery={};Object.keys(query).forEach(function(key){if(query[key]!==undefined){filterQuery[key]=query[key];}});var pathnamelinkTag=/^\//.test(pathname)?'':'/';var querylinkTag=Object.keys(filterQuery).length?'?':'';return"".concat(host).concat(pathnamelinkTag).concat(pathname).concat(querylinkTag).concat(queryString.stringify(filterQuery,{encode:true}));}/**
   * 使用query对象拼接地址
   *
   * @static
   * @param {string} url
   * @param {{ [key: string]: any }} query
   * @returns
   * @memberof AppUrlUtil
   */},{key:"withUrlQueryString",value:function withUrlQueryString(url,query){var filterQuery={};Object.keys(query).forEach(function(key){if(query[key]!==undefined){filterQuery[key]=query[key];}});var linkTag=url.indexOf('?')>-1?'&':'?';if(!Object.keys(filterQuery).length){linkTag='';}return"".concat(url).concat(linkTag).concat(queryString.stringify(filterQuery,{encode:true}));}/**
   * 获取当前location query对象
   *
   * @static
   * @param {string} [search]
   * @returns
   * @memberof AppUrlUtil
   */},{key:"getLocationQuery",value:function getLocationQuery(search){var currentUrlQuery=queryString.parse(search||window.location.search);return currentUrlQuery;}}]);return AppUrlUtil;}();AppUrlUtil.QueryGroupFields=(_AppUrlUtil$QueryGrou={},_defineProperty(_AppUrlUtil$QueryGrou,AppUrlQueryGroup.referral,[ReferralGroup.referral_code]),_defineProperty(_AppUrlUtil$QueryGrou,AppUrlQueryGroup.UTM,[UTMGroup.utm_source,UTMGroup.utm_medium,UTMGroup.utm_campaign]),_AppUrlUtil$QueryGrou);